const ebayFeedTypes = [
  {
    label: 'LMS_ADD_FIXED_PRICE_ITEM',
    value: 'LMS_ADD_FIXED_PRICE_ITEM',
  }, {
    label: 'LMS_END_FIXED_PRICE_ITEM',
    value: 'LMS_END_FIXED_PRICE_ITEM',
  }, {
    label: 'LMS_REVISE_FIXED_PRICE_ITEM',
    value: 'LMS_REVISE_FIXED_PRICE_ITEM',
  }, {
    label: 'LMS_RELIST_FIXED_PRICE_ITEM',
    value: 'LMS_RELIST_FIXED_PRICE_ITEM',
  }, {
    label: 'LMS_VERIFY_ADD_FIXED_PRICE_ITEM',
    value: 'LMS_VERIFY_ADD_FIXED_PRICE_ITEM',
  }, {
    label: 'LMS_ADD_ITEM',
    value: 'LMS_ADD_ITEM',
  }, {
    label: 'LMS_END_ITEM',
    value: 'LMS_END_ITEM',
  }, {
    label: 'LMS_REVISE_ITEM',
    value: 'LMS_REVISE_ITEM',
  }, {
    label: 'LMS_RELIST_ITEM',
    value: 'LMS_RELIST_ITEM',
  }, {
    label: 'LMS_VERIFY_ADD_ITEM',
    value: 'LMS_VERIFY_ADD_ITEM',
  }, {
    label: 'LMS_REVISE_INVENTORY_STATUS',
    value: 'LMS_REVISE_INVENTORY_STATUS',
  },
];

export default ebayFeedTypes;
